import React, { useEffect, useState } from "react";
import { ImageOff } from "lucide-react";
import { resolveMediaUrl } from "../utils/resolveMediaUrl";
import "./SafeMediaImage.css";

/**
 * Renders a stored media URL. If missing or the file fails to load, shows a default icon.
 */
export default function SafeMediaImage({
  src,
  alt = "",
  className = "",
  fallbackClassName = "",
  iconSize = 28,
  ...rest
}) {
  const url = resolveMediaUrl(src);
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    setFailed(false);
  }, [url]);

  if (!url || failed) {
    return (
      <span
        className={`safe-media-fallback${fallbackClassName ? ` ${fallbackClassName}` : ""}`}
        role={alt ? "img" : undefined}
        aria-label={alt || undefined}
        aria-hidden={alt ? undefined : true}
      >
        <ImageOff size={iconSize} strokeWidth={1.5} />
      </span>
    );
  }

  return (
    <img
      src={url}
      alt={alt}
      className={className}
      onError={() => setFailed(true)}
      {...rest}
    />
  );
}
